import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	titleInvitesSent: {
		id: 'invite-on-third-party-link.flag.title.invites-sent',
		defaultMessage:
			'{inviteCount, plural, one {Invite successfully sent} other {Invites successfully sent}}',
		description:
			'Title displayed at the top of a success flag shown when teammate invites are sent successfully. The placeholder {inviteCount} determines singular or plural text (e.g., "Invite successfully sent" or "Invites successfully sent").',
	},
	descriptionInvitesSent: {
		id: 'invite-on-third-party-link.flag.description.invites-sent',
		defaultMessage:
			'{inviteCount} {inviteCount, plural, one {teammate} other {teammates}} will get an email inviting them to {productName}.',
		description:
			'Body text in a success flag showing how many teammates will receive invitations. The placeholder {inviteCount} determines singular/plural form, and {productName} is substituted with the product name (e.g., "Jira").',
	},
	descriptionRequestAccess: {
		id: 'invite-on-third-party-link.flag.description.invites-sent-with-request-access',
		defaultMessage: 'Admin may need to approve some teammates before they can join {productName}.',
		description:
			'Additional note displayed in a success flag informing users that some teammates may require admin approval before they can access the product. The {productName} placeholder is replaced with the product name.',
	},
});
